<template>
  <div>
    <main-layout>
      <v-container grid-list-md class="signup-form">
        <v-tabs
          v-model="currentView"
          class="mb-4"
          color="white"
          :slider-color="$vuetify.theme.primary"
          show-arrows
          @change="changeView"
        >
          <v-tab href="#super10" value="super10" ripple>Super10</v-tab>
          <v-tab href="#super100" value="super100" ripple>Super100</v-tab>
        </v-tabs>
        <div class="d-flex justify-space-between mb-4">
          <div>
            <h1 class="mb-2">{{ $t('Applicant') }}</h1>
          </div>
          <div
            style="display: flex; align-items: center; justify-content: flex-end; column-gap: 4px"
          >
            <v-btn
              :outline="pagination.totalItems > 0"
              color="grey"
              :disabled="pagination.totalItems === 0"
              class="ma-0 mb-1"
              @click="exportUser()"
            >
              <i class="fas fa-file-export mr-1"></i>
              {{ $t('export') }}
            </v-btn>
            <v-btn outline color="primary" class="ma-0 mb-1" @click="toggleFilterSearch()">
              Filter/Search
            </v-btn>
          </div>
        </div>
        <v-layout row wrap class="mb-4" v-if="isActiveFilter">
          <v-flex xs12 md3>
            <span class="caption">
              {{ $t('Registration number') }}
            </span>
            <v-text-field v-model="filter.id" outline dense hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 md3>
            <span class="caption">
              {{ $t('Name - Surname') }}
            </span>
            <v-text-field v-model="filter.name" outline dense hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 md3>
            <span class="caption">
              {{ $t('Phone number') }}
            </span>
            <v-text-field v-model="filter.telephone_no" outline dense hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 md3>
            <span class="caption">
              {{ $t('Applied by') }}
            </span>
            <v-select
              v-model="filter.register_type"
              :items="applyByItems"
              item-text="text"
              item-value="value"
              outline
              dense
              hide-details
              @change="onChangeRegisterType"
            ></v-select>
          </v-flex>
          <v-flex xs12 md3>
            <span class="caption">
              {{ $t('gender') }}
            </span>
            <v-select
              v-model="filter.gender"
              :items="genders"
              item-text="text"
              item-value="value"
              outline
              dense
              hide-details
            ></v-select>
          </v-flex>
          <template v-if="filter.register_type === 'suggest'">
            <v-flex xs12 md3>
              <span class="caption">
                {{ $t('Referrer_s name') }}
              </span>
              <v-text-field v-model="filter.suggest_name" outline dense hide-details></v-text-field>
            </v-flex>
            <v-flex xs12 md3>
              <span class="caption">
                {{ $t('Referrer_s phone number') }}
              </span>
              <v-text-field v-model="filter.suggest_telephone_no" outline dense hide-details></v-text-field>
            </v-flex>
          </template>
          <v-flex xs12 md3>
            <span class="caption">
              {{ $t('Status') }}
            </span>
            <multiselect
              v-model="filter.status"
              :options="statusOptions"
              :searchable="true"
              selectLabel
              selectedLabel
              deselect-label
              :multiple="true"
              :placeholder="' '"
            ></multiselect>
          </v-flex>
          <v-flex xs12 md3>
            <span class="caption">
              {{ $t('Tag') }}
            </span>
            <multiselect
              v-model="filter.tags"
              :options="tagOptions"
              :searchable="true"
              selectLabel
              selectedLabel
              deselect-label
              :multiple="true"
              :placeholder="' '"
            ></multiselect>
          </v-flex>
          <v-flex xs12 md3 class="ml-auto mt-auto text-xs-right">
            <v-btn depressed color="primary" class="ma-1" @click="searchFilter()">
              {{ $t('Search') }}
            </v-btn>
          </v-flex>
        </v-layout>
        <date-filter
          v-model="selectedDate"
          class="mb-2"
          defaultFilter="today"
          @input="searchFilter()"
        ></date-filter>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="users"
          :pagination.sync="pagination"
          @update:pagination="updatePagination"
          hide-actions
          class="elevation-1"
        >
          <template v-slot:items="{ item }">
            <td class="nowrap">{{ item.registered_at }}</td>
            <td class="nowrap">{{ item.no }}</td>
            <td class="nowrap">{{ item.first_name }}</td>
            <td class="nowrap">{{ item.gender }}</td>
            <td class="nowrap">{{ item.age }}</td>
            <td class="nowrap">{{ item.birth_date }}</td>
            <td class="nowrap">{{ item.telephone_no }}</td>
            <td class="nowrap">{{ item.line_id }}</td>
            <td class="nowrap">{{ item.line_name }}</td>
            <!-- <td class="nowrap">{{ item.personal_description }}</td> -->
            <td class="nowrap">
              <i
                class="fas fa-search primary--text"
                style="font-size: 20px; cursor: pointer"
                @click="viewInfo(item)"
              ></i>
            </td>
            <td class="nowrap">
              <div class="d-flex" style="column-gap: 2px">
                <template v-for="(url, index) in getAssetUrl(item.image_url_batch)">
                  <i
                    class="fas fa-link"
                    :class="[item.image_url_batch_read_index.includes(index)? 'grey--text' : 'primary--text']"
                    style="font-size: 20px; cursor: pointer"
                    :key="index"
                    
                    @click="gotoLink(url.link, { type: 'image', id: item.id, index })"
                    v-if="url.type === 'link'"
                  ></i>
                  <i
                    class="fas fa-image"
                    :class="[item.image_url_batch_read_index.includes(index)? 'grey--text' : 'primary--text']"
                    style="font-size: 20px; cursor: pointer"
                    :key="index"
                    @click="viewImage(url.link, { type: 'image', id: item.id, index })"
                    v-else
                  ></i>
                </template>
              </div>
            </td>
            <td class="nowrap">
              <div class="d-flex" style="column-gap: 2px">
                <template v-for="(url, index) in getAssetUrl(item.video_url_batch)">
                  <i
                    class="fas fa-link"
                    :class="[item.video_url_batch_read_index.includes(index)? 'grey--text' : 'primary--text']"
                    style="font-size: 20px; cursor: pointer"
                    :key="index"
                    @click="gotoLink(url.link, { type: 'video', id: item.id, index })"
                    v-if="url.type === 'link'"
                  ></i>
                  <i
                    class="fas fa-film"
                    :class="[item.video_url_batch_read_index.includes(index)? 'grey--text' : 'primary--text']"
                    style="font-size: 20px; cursor: pointer"
                    :key="index"
                    @click="viewVideo(url.link, { type: 'video', id: item.id, index })"
                    v-else
                  ></i>
                </template>
              </div>
            </td>
            <td class="nowrap">{{ item.register_type_text }}</td>
            <td class="nowrap">{{ item.suggest_first_name }}</td>
            <td class="nowrap">{{ item.suggest_telephone_no }}</td>
            <td class="nowrap">
              {{ item.status_label || '-' }} <span class="fas fa-pencil-alt primary--text text-xs-center" style="cursor: pointer;" @click="editStatus(item)"></span>
            </td>
            <td class="nowrap">
              <span class="fas fa-tag primary--text text-xs-center" style="cursor: pointer;" @click="editTag(item)"></span>
            </td>
            <td class="nowrap">
              <v-btn
                fab
                outline
                rounded
                color="primary"
                class="extra-small ma-1"
                @click="sendMessage(item)"
              >
                <i class="fas fa-paper-plane"></i>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-container>
      <v-dialog v-model="showDialogInfo" persistent width="500">
        <v-card>
          <v-card-text>
            <h3>{{ $t('introduction of oneself - Dream') }}</h3>
            <p style="word-break: break-all;">{{ popupInfo.info }}</p>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="justify-end">
            <v-btn depressed color="primary" class="ma-1" @click="showDialogInfo = false">
              {{ $t('close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showDialogImage" persistent width="500">
        <v-card>
          <div class="text-xs-right">
            <v-btn @click="()=>downloadFile(popupInfo.image, 'image')" icon :loading="isLoadingFile" :disabled="isLoadingFile">
              <span class="fas fa-download primary--text"></span>
            </v-btn>
          </div>
          <v-card-text v-if="popupInfo.image">
            <v-img :src="popupInfo.image" style="height: 400px;"></v-img>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="justify-end">
            <v-btn depressed color="primary" class="ma-1" :disabled="isLoadingFile" @click="showDialogImage = false">
              {{ $t('close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showDialogVideo" persistent width="500">
        <v-card>
          <div class="text-xs-right">
            <v-btn @click="()=>downloadFile(popupInfo.video, 'video')" icon :loading="isLoadingFile" :disabled="isLoadingFile">
              <span class="fas fa-download primary--text"></span>
            </v-btn>
          </div>
          <v-card-text v-if="popupInfo.video">
            <video width="100%" height="100%" style="height: 400px" controls>
              <source :src="popupInfo.video" type="video/mp4" />
              <source :src="popupInfo.video" type="video/mov" />
              <source :src="popupInfo.video" type="video/m4v" />
              <source :src="popupInfo.video" type="video/MOV" />
              <!-- <source src="https://d2xauako2dpjc2.cloudfront.net/sso/1714707595302_x.mp4" type="video/mp4" /> -->
            </video>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="justify-end">
            <v-btn depressed color="primary" :disabled="isLoadingFile" class="ma-1" @click="closeVideoDialog()">
              {{ $t('close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showEditStatus" persistent width="500">
        <v-card>
          <v-card-text>
            <multiselect
              v-model="statusSelected.status"
              class="status-dropdown"
              :options="statusOptions"
              :searchable="true"
              selectLabel
              selectedLabel
              deselect-label
              :multiple="false"
              :taggable="true"
              @tag="onSelectStatus"
              :placeholder="$t('Status')"
            ></multiselect>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="justify-center">
            <v-btn outline color="primary" class="ma-1" @click="showEditStatus = false">
              {{ $t('cancel') }}
            </v-btn>
            <v-btn depressed color="primary" class="ma-1" @click="saveStatus">
              {{ $t('Save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showEditTag" persistent width="500">
        <v-card>
          <v-card-text>
            <tags
              v-model="usertag"
              class="tag-dropdown"
              :combobox="true"
              :tags="tagSelected.tags"
              :itemOption="tagOptions"
              :btnText="$t('Add tag')"
              @before-adding-tag="checkUserTags"
              ref="userTag"
            ></tags>
            <div class="mt-2" v-if="errorTag.length">
              <span class="error--text mr-2" v-for="(item, index) in errorTag" :key="`error-${index}`">{{ $t(item) }}</span>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="justify-center">
            <v-btn outline color="primary" class="ma-1" @click="showEditTag = false">
              {{ $t('cancel') }}
            </v-btn>
            <v-btn depressed color="primary" class="ma-1" @click="saveTag">
              {{ $t('Save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </main-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import XLSX from 'xlsx'

import Multiselect from 'vue-multiselect'

import DateFilter from '@/components/view/analytics/DateFilter'
import Tags from '@/components/elements/Tags'
export default {
  components: { Multiselect, DateFilter, Tags },
  data: () => ({
    currentView: '',
    selectedDate: {
      start: dayjs().format('YYYY-MM-DD') + ' 00:00',
      end: dayjs().format('YYYY-MM-DD') + ' 23:59',
    },
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 100, // -1 for All",
      sortBy: '',
      totalItems: 0,
    },
    filter: {
      start_registered_at: '',
      end_registered_at: '',
      id: '',
      name: '',
      telephone_no: '',
      register_type: '',
      gender: '',
      suggest_name: '',
      suggest_telephone_no: '',
      status: [],
      tags: []
    },
    users: [],
    loading: false,
    isActiveFilter: false,
    showDialogInfo: false,
    showDialogImage: false,
    showDialogVideo: false,
    allStatus: [],
    allTags: [],
    popupInfo: {
      info: '',
      image: null,
      video: null,
    },
    statusSelected: {
      id: null,
      status: null
    },
    tagSelected: {
      id: null,
      tags: []
    },
    showEditStatus: false,
    showEditTag: false,
    statusOptions: [],
    tagOptions: [],
    errorTag: [],
    usertag: '',
    isLoadingFile: false
  }),
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang',
      userStatus: 'getUserStatus',
      userTags: 'getUserTags',
    }),
    headers() {
      return [
        {
          text: this.$t('Date of registration'),
          value: 'registered_at',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('Registration number'),
          value: 'no',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('Name - Surname'),
          value: 'first_name',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('Gender'),
          value: 'gender',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('Age'),
          value: 'age',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('Date / Month / Year of birth'),
          value: 'birth_date',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('Phone number'),
          value: 'telephone_no',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('LINE ID'),
          value: 'line_id',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('LINE name'),
          value: 'line_name',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('Self-introduction'),
          value: 'personal_description',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('Profile picture'),
          value: 'image_url_batch',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('Video clip'),
          value: 'video_url_batch',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('Applied by'),
          value: 'register_type',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('Referrer_s name'),
          value: 'suggest_first_name',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('Referrer_s phone number'),
          value: 'suggest_telephone_no',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('Status'),
          value: 'status_label',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('Tag'),
          value: 'tags_label',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('Send message'),
          value: 'actions',
          align: 'center',
          sortable: false,
        },
      ]
    },
    genders() {
      return [
        { text: this.$t('male'), value: 'male' },
        { text: this.$t('female'), value: 'female' },
      ]
    },
    applyByItems() {
      return [
        { text: this.$t('oneself'), value: 'oneself' },
        { text: this.$t('suggest'), value: 'suggest' },
      ]
    },
  },
  async mounted() {
    if (this.$route.query && this.$route.query.page) {
      const tab = this.$route.query.page
      this.currentView = tab
    } else {
      this.$router.replace({ query: { page: 'super10' } })
      this.currentView = 'super10'
    }
    await this.getUserStatusList()
    await this.getUserTagList()
    await this.getUser()
  },
  methods: {
    changeView(view) {
      this.$router.replace({ query: { page: view } })
    },
    async getUser(isGetAll = false) {
      try {
        if (this.loading) return
        this.$store.dispatch('loading')
        const params = {
          system: this.currentView,
          limit: isGetAll ? this.pagination.totalItems : this.pagination.rowsPerPage,
          offset: isGetAll ? 0 : this.pagination.rowsPerPage * (this.pagination.page - 1),
          start_registered_at: this.selectedDate.start,
          end_registered_at: this.selectedDate.end,
          id: this.filter.id,
          name: this.filter.name,
          telephone_no: this.filter.telephone_no,
          register_type: this.filter.register_type,
          gender: this.filter.gender,
          suggest_name: this.filter.suggest_name,
          suggest_telephone_no: this.filter.suggest_telephone_no,
          status: this.filter.status.join(','),
          tags: this.filter.tags.join(',')
        }
        const response = await this.get(`super10/applicant`, { params })
        if (response.success) {
          const prefix = this.currentView === 'super10' ? 'A' : 'B'
          const users = response.result.applicant.map((item) => {
            const registerTypeText = this.applyByItems.find(a => a.value === item.register_type)
            return {
              ...item,
              registered_at: item.registered_at
                ? dayjs(item.registered_at).format('DD/MM/YYYY HH:mm')
                : '-',
              id: item.id,
              no: item.id ? prefix + item.id.toString().padStart(8, '0') : '-',
              first_name: item.first_name
                ? `${item.first_name || ''} ${item.last_name || ''}`
                : '-',
              gender: item.gender ? this.$t(item.gender) : '-',
              age: item.age,
              birth_date: item.birth_date ? dayjs(item.birth_date).format('DD/MM/YYYY') : '-',
              telephone_no: item.telephone_no || '-',
              line_id: item.line_id || '-',
              line_name: item.line_name || '-',
              personal_description: item.personal_description || '-',
              video_url_batch: item.video_url_batch || [],
              image_url_batch: item.image_url_batch || [],
              register_type: item.register_type,
              register_type_text: registerTypeText ? registerTypeText.text : item.register_type,
              suggest_first_name: item.suggest_first_name
                ? `${item.suggest_first_name || ''} ${item.suggest_last_name || ''}`
                : '-',
              suggest_telephone_no: item.suggest_telephone_no || '-',
              image_url_batch_read_index: item.image_url_batch_read_index || [],
              video_url_batch_read_index: item.video_url_batch_read_index || [],
              action: '',
            }
          })
          if (!isGetAll) {
            this.users = users
            this.pagination.totalItems = response.result.total_applicant
          } else {
            this.$store.dispatch('loading')
            this.pagination.totalItems = response.result.total_applicant
            return users
          }
        }
        this.$store.dispatch('loading')
      } catch (error) {
        console.log('error', error)
        this.users = []
        this.$store.dispatch('loading')
      }
    },
    async updateUser(data, callback) {
      try {
        if (this.loading) return
        this.$store.dispatch('loading')
        const payload = {
          system: this.currentView,
          ...data
        }
        const response = await this.patch(`super10/update-applicant`, payload)
        if (response.success && callback) {
          callback()
        } else {
          await this.$swal.fire({
            title: this.$t('Unsuccessful'),
            text: response.data && response.data.message || response.message || '',
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            reverseButtons: true
          })
        }
        
      } catch (error) {
        console.log('error', error)
        await this.$swal.fire({
          title: this.$t('Unsuccessful'),
          text: (error && error.response && error.response.data && error.response.data.message) || (error && error.response && error.response.message) || '',
          type: 'error',
          confirmButtonText: this.$t('Confirm'),
          reverseButtons: true
        })
      } finally {
        if (this.$store.state.loading) {
          this.$store.dispatch('loading')
        }
      }
    },
    updatePagination(e) {
      // console.log(e)
    },
    sendMessage(item) {
      this.$router.push({ name: 'allinonechat', query: { userid: item.user_id, app: 'line' } })
    },
    async exportUser() {
      try {
        const users = await this.getUser(true)
        this.generateFile(users)
      } catch (error) {
        console.log(error)
      }
    },
    generateFile(items) {
      items = items.map((item) => {
        return {
          [this.$t('Date of registration')]: item.registered_at,
          [this.$t('Registration number')]: item.no,
          [this.$t('Name - Surname')]: item.first_name,
          [this.$t('Gender')]: item.gender,
          [this.$t('Age')]: item.age,
          [this.$t('Date / Month / Year of birth')]: item.birth_date,
          [this.$t('Phone number')]: item.telephone_no,
          [this.$t('LINE ID')]: item.line_id,
          [this.$t('LINE name')]: item.line_name,
          [this.$t('Self-introduction')]: item.personal_description,
          [this.$t('Profile picture')]: item.image_url_batch.join(','),
          [this.$t('Video clip')]: item.video_url_batch.join(','),
          [this.$t('Applied by')]: item.register_type_text,
          [this.$t('Referrer_s name')]: item.suggest_first_name,
          [this.$t('Referrer_s phone number')]: item.suggest_telephone_no,
        }
      })
      const usersWs = XLSX.utils.json_to_sheet(items)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, usersWs, this.currentView)
      XLSX.writeFile(wb, `${this.currentView}.xlsx`)
    },
    toggleFilterSearch() {
      this.isActiveFilter = !this.isActiveFilter
    },
    async searchFilter() {
      this.pagination.page = 1
      this.pagination.totalItems = 0
      await this.getUser()
    },
    getAssetUrl(urls) {
      if (!urls || !urls.length) {
        return []
      } else {
        return urls.map((item) => {
          return { link: item, type: item && (item.includes('sso') || item.includes('superjeew')) ? 'uploaded' : 'link' }
        })
      }
    },
    viewInfo(item) {
      this.popupInfo.info = item.personal_description || ''
      this.showDialogInfo = true
    },
    async viewImage(image, data) {
      await this.stampMedia(data)
      this.popupInfo.image = image
      this.showDialogImage = true
    },
    async viewVideo(video, data) {
      await this.stampMedia(data)
      this.popupInfo.video = null
      this.popupInfo.video = video
      this.showDialogVideo = true
    },
    onChangeRegisterType() {
      this.filter.suggest_name = ''
      this.filter.suggest_telephone_no = ''
    },
    async gotoLink(link, data) {
      await this.stampMedia(data)
      window.open(link)
    },
    closeVideoDialog() {
      this.popupInfo.video = null
      this.showDialogVideo = false
    },
    async stampMedia(data) {
      try {
        if (!data) return
        const findIndex = this.users.findIndex(item => item.id === data.id)
        const arrRead = this.users[findIndex][`${data.type}_url_batch_read_index`]
        if (arrRead.includes(data.index)) return

        const payload = {
          system: this.currentView, // [super10, super100]
          ...data
        }
        const response = await this.post(`super10/stamp-read`, payload)
        if (response.success) {
          if (findIndex > -1) {
            if (!arrRead.includes(data.index)) {
              this.users[findIndex][`${data.type}_url_batch_read_index`].push(data.index)
            }
          }
        } else {
          await this.$swal.fire({
            title: this.$t('Unsuccessful'),
            text: response.data && response.data.message || response.message || '',
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            reverseButtons: true
          })
        }
      } catch (error) {
        console.log('error', error)
        await this.$swal.fire({
          title: this.$t('Unsuccessful'),
          text: (error && error.response && error.response.data && error.response.data.message) || (error && error.response && error.response.message) || '',
          type: 'error',
          confirmButtonText: this.$t('Confirm'),
          reverseButtons: true
        })
      }
    },
    editStatus(item) {
      this.statusSelected.id = item.id
      this.statusSelected.status = item.status_label
      this.showEditStatus = true
    },
    editTag(item) {
      this.tagSelected.id = item.id
      this.tagSelected.tags = item.tags_label.map((item, index) => ({ id: index, text: item }))
      this.showEditTag = true
    },
    async saveStatus() {
      const payload = {
        id: this.statusSelected.id,
        status_label: this.statusSelected.status
      }

      const callback = async () => {
        const findIndex = this.users.findIndex(item => item.id === this.statusSelected.id)
        if (findIndex > -1) {
          this.users[findIndex]['status_label'] = this.statusSelected.status
        }
        this.statusOptions = []
        await this.getUserStatusList()
        this.showEditStatus = false
      }
      
      await this.updateUser(payload, callback)
    },
    async saveTag() {
      if (this.errorTag.length) return
      const tags = [...this.tagSelected.tags.map(item => item.text)]
      const payload = {
        id: this.tagSelected.id,
        tags_label: tags
      }

      const callback = async () => {
        const findIndex = this.users.findIndex(item => item.id === this.tagSelected.id)
        if (findIndex > -1) {
          this.users[findIndex]['tags_label'] = tags
        }
        this.tagOptions = []
        await this.getUserTagList()
        this.showEditTag = false
      }
      await this.updateUser(payload, callback)
    },
    async getUserStatusList() {
      this.statusOptions = []
      await this.$store.dispatch('loadStatus')
      if (this.userStatus.length > 0) {
        this.statusOptions = this.userStatus.map(item => item.name)
      }
    },
    async getUserTagList() {
      await this.$store.dispatch('loadTags')
      if (this.userTags.length > 0) {
        this.tagOptions = this.userTags.map(item => item.name)
        const userTag = this.$refs.userTag
        if (userTag) {
          userTag.refreshTags()
        }
      }
    },
    checkUserTags(obj) {
      this.errorTag = []
      if (obj.tag.text.length > 25) {
        this.errorTag.push('Message cannot be longer than 20 alphabets')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorTag.push('Duplicate Tag')
        obj.error()
      } else obj.addTag()
    },
    onSelectStatus(value) {
      this.statusOptions.unshift(value)
      this.statusSelected.status = value
    },
    downloadFile(url) {
      if (this.isLoadingFile) return

      this.isLoadingFile = true

      const  getFileName = () => {
        const fileName = url.substring(url.lastIndexOf('/') + 1);
        return fileName
      }
      const newUrl = url.replace('d2xauako2dpjc2.cloudfront.net', 'zwizai-platform.s3.ap-southeast-1.amazonaws.com')

      fetch(newUrl)
        .then(response => response.blob())
        .then(blob => {
          const blobURL = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = blobURL;
          a.download = getFileName();  // กำหนดชื่อไฟล์ที่ต้องการบันทึก
          document.body.appendChild(a);
          a.click();  // เรียกการคลิกลิงก์เพื่อดาวน์โหลด
          window.URL.revokeObjectURL(blobURL);  // ลบ URL Blob ทิ้งเมื่อไม่ใช้งาน
          document.body.removeChild(a);  // ลบลิงก์ออกจาก DOM
        })
        .catch(error => console.error('Error downloading file:', error))
        .finally(() => {
          this.isLoadingFile = false
        })
    }
  },
}
</script>

<style scoped>
.nowrap {
  white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/components/view/home/Home.vue